var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "site-profile-container" }, [
    _c("a", { staticClass: "nav-back", on: { click: _vm.goBack } }, [
      _vm._v(_vm._s(_vm.$t("back"))),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "header" }, [
      _c("label", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("settings.tab.siteProfile"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btns" }, [
        _vm.editable && !_vm.isEdit
          ? _c(
              "button",
              { staticClass: "btn btn--orange", on: { click: _vm.edit } },
              [_vm._v(_vm._s(_vm.$t("action.edit")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isEdit
          ? _c(
              "button",
              { staticClass: "btn btn--darkblue", on: { click: _vm.cancel } },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isEdit
          ? _c(
              "button",
              { staticClass: "btn btn--orange", on: { click: _vm.save } },
              [_vm._v(_vm._s(_vm.$t("action.save")))]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main" }, [
      _c(
        "div",
        { staticClass: "tabs" },
        _vm._l(_vm.sites, function (site) {
          return _c(
            "label",
            {
              key: site.code,
              class: { active: _vm.currentSiteId === site.id },
              on: {
                click: function ($event) {
                  return _vm.updateCurrentSite(site.id)
                },
              },
            },
            [_vm._v(_vm._s(site.code))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "basic-info" },
          [
            _c("SiteProfileForm", {
              ref: "siteProfileForm",
              attrs: { site: _vm.siteDetail, isEdit: _vm.isEdit },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "users" },
          [_c("SiteProfileUsers", { attrs: { users: _vm.users } })],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }